import { render, staticRenderFns } from "./intelligentDetecteTemplate.vue?vue&type=template&id=533ef0c3&scoped=true&"
import script from "./intelligentDetecteTemplate.vue?vue&type=script&lang=js&"
export * from "./intelligentDetecteTemplate.vue?vue&type=script&lang=js&"
import style0 from "./intelligentDetecteTemplate.vue?vue&type=style&index=0&id=533ef0c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533ef0c3",
  null
  
)

export default component.exports